import { Component, OnInit, ViewChild } from '@angular/core';
import { ConsultaGeneralUsuarioComponent } from '../consulta-general-usuario/consulta-general-usuario.component';
import { ButtonColumnType, CustomTableComponent, DataColumnType, ICustomTable } from 'lib-base';
import { PagoService } from '../../../services/pago.service';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom, forkJoin } from 'rxjs';
import { IGetMisPagos } from '../../../shared/interfaces/recaudo';
import { DetalleTransaccionPSEComponent } from './detalle-transaccion-pse/detalle-transaccion-pse.component';

@Component({
  selector: 'app-mis-pagos',
  standalone: true,
  imports: [ConsultaGeneralUsuarioComponent, CustomTableComponent, DetalleTransaccionPSEComponent],
  templateUrl: './mis-pagos.component.html',
  styleUrl: './mis-pagos.component.scss'
})
export class MisPagosComponent implements OnInit {

  trans: any = {};
  customTable !: ICustomTable;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;
  @ViewChild(DetalleTransaccionPSEComponent) detalleTransaccionPSE !: DetalleTransaccionPSEComponent;

  constructor(
    private readonly _ps: PagoService, 
    private readonly _t: TranslateService) { }

  ngOnInit(): void {
    this.translate();
    this.getMisPagos();
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      misPagos: this._t.get('common.misPagos'),
      pago: this._t.get('common.pago'),
      vigencia: this._t.get('common.vigencia'),
      periodo: this._t.get('common.periodo'),
      banco: this._t.get('common.banco'),
      medioPago: this._t.get('common.medioPago'),
      fechaPago: this._t.get('common.fechaPago'),
      impuesto: this._t.get('common.impuesto'),
      concepto: this._t.get('common.concepto'),
      valorAplicadoConcepto: this._t.get('common.valorAplicadoConcepto'),
      totalPago: this._t.get('common.totalPago'),
    }));
    this.configureTable();
  }

  private configureTable() {
    this.customTable = {
      settings: {
        table: {
          rows: 7,
        }
      },
      columns: [
        {
          field: 'pago',
          header: this.trans.pago,
          dataType: DataColumnType.NUMBER
        },
        {
          field: 'vigencia',
          header: this.trans.vigencia,
          dataType: DataColumnType.NUMBER
        },
        {
          field: 'periodo',
          header: this.trans.periodo,
          dataType: DataColumnType.NUMBER
        },
        {
          field: 'banco',
          header: this.trans.banco,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'medioPago',
          header: this.trans.medioPago,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'fechaPago',
          header: this.trans.fechaPago,
          dataType: DataColumnType.DATE
        },
        {
          field: 'impuesto',
          header: this.trans.impuesto,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'concepto',
          header: this.trans.concepto,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'valorAplicadoConcepto',
          header: this.trans.valorAplicadoConcepto,
          dataType: DataColumnType.MONEY
        },
        {
          field: 'totalPago',
          header: this.trans.totalPago,
          dataType: DataColumnType.MONEY
        },

        {
          field: 'abrir',
          header: '',
          icon: 'pi pi-search',
          class: 'button-edit p-button-outlined pt-2 pb-2',
          width: '0rem',
          buttonType: ButtonColumnType.CUSTOM,
          onClick: (event: Event, data: IGetMisPagos) => this.openDetallePSE(data),          
        }
      ]
    } as ICustomTable;
  }

  private getMisPagos() {
    this._ps.getMisPagos().subscribe({
      next: (res: IGetMisPagos[]) => {
        this.customTableComponent.data = res;
      },
    });
  }

  private openDetallePSE(data: IGetMisPagos) {
    this.detalleTransaccionPSE.show(data.pago);
  }

}
